import { provideChameleonDesignSystem } from '../provideChameleonDesignSystem';
import { chameleonNav } from './Nav.definition';
export function registerCustom(prefix, node) {
    return provideChameleonDesignSystem({ prefix, node }).register(chameleonNav({ prefix }));
}
